import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { CheckIcon } from "@phosphor-icons/react/dist/csr/Check";
import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { cn } from "@volca/ui/lib/utils";
import {
  SELECTION_AGGREGATE_LABELS,
  type SelectionAggregate,
  type SelectionSummary,
} from "./selection-summary";
import { ToolbarSegment } from "./toolbar-segment";

interface SelectionSummaryControlProps {
  summary: SelectionSummary;
}

export const SelectionSummaryControl = ({
  summary,
}: SelectionSummaryControlProps) => {
  const [selectedAggregate, setSelectedAggregate] =
    useState<SelectionAggregate | null>(null);
  const selectedOption = summary.options.find(
    (option) => option.aggregate === selectedAggregate,
  );
  const activeOption = selectedOption ?? summary.defaultOption;

  return (
    <ToolbarSegment className="mr-6">
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              variant="ghost"
              size="sm"
              aria-label={`Selection summary: ${SELECTION_AGGREGATE_LABELS[activeOption.aggregate]}`}
            />
          }
        >
          <span className="font-medium">
            {SELECTION_AGGREGATE_LABELS[activeOption.aggregate]}:
          </span>
          <span>{activeOption.result}</span>
          <CaretDownIcon data-icon="inline-end" className="text-subtle" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-48">
          {summary.options.map((option) => (
            <DropdownMenuItem
              key={option.aggregate}
              className="justify-between gap-4"
              onClick={() => setSelectedAggregate(option.aggregate)}
            >
              {SELECTION_AGGREGATE_LABELS[option.aggregate]}
              <span className="flex items-center gap-2">
                <span className="text-subtle tabular-nums">
                  {option.result}
                </span>
                <CheckIcon
                  className={cn("h-4 w-4", {
                    invisible: option.aggregate !== activeOption.aggregate,
                  })}
                />
              </span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </ToolbarSegment>
  );
};
